import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/telegram/")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin/channels",
      search: { network: "telegram", section: "channels" },
      replace: true,
    });
  },
});
